import {
  AxiosPost,
  AxiosGet
} from "../../helpers/microserviceAPIs"
import { telerecoveryApiUrl } from "../../config/microservicesUrls"

const api_url = telerecoveryApiUrl()

export async function trApiFindStaffNumber(jwt, staffId, organization_Id, organization_alias, staff_alias) {
  return await AxiosGet(jwt, `${api_url}/Numbers/FindByStaff?staffId=${staffId}&groupId=${organization_Id}&groupAlias=${organization_alias}&staffAlias=${staff_alias}`)
}

//SMS
export async function trApiGetSMSHistory(jwt, staffPhoneNumber, participant_phone_primary, participant_id, orgId) {
  return await AxiosGet(jwt, `${api_url}/SMS?from=${staffPhoneNumber}&to=${participant_phone_primary}&caseUserId=${participant_id}&organizationId=${orgId}`)
}

export async function trApiSendSMSToParticipant(jwt, smsData) {
  return await AxiosPost(jwt, `${api_url}/SMS`, smsData, 'multipart/form-data')
}

export async function trApiSMSSetRead(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/SMS/SetRead`, body)
}

//GroupMessages
export async function trApiGetSMSConversations(jwt, staffId) {
  return await AxiosGet(jwt, `${api_url}/Api/Conversations/List?peerId=${staffId}`)
}

export async function trApiSMSGetBulkHistory(jwt, staffNumber, orgId, body) {
  return await AxiosPost(jwt, `${api_url}/SMS/BulkHistory?staffNumber=${staffNumber}&organizationId=${orgId}`, body)
}

export async function trApiGetChatConversations(jwt, staffId, orgId) {
  return await AxiosGet(jwt, `${api_url}/Chat/GetPeerConversations?peerId=${staffId}&orgId=${orgId}`)
}

export async function trApiChatConvSetRead(jwt, data) {
  return await AxiosPost(jwt, `${api_url}/Chat/SetRead`, data)
}

//Broadcast Messages
export async function trApiGetBroadcastsListByStaffGroupId(jwt, staffGroupId) {
  return await AxiosGet(jwt, `${api_url}/Api/BroadcastGroup/List?soarGroupId=${staffGroupId}`)
}

export async function trApiGetBroadcastById(jwt, broadcastGroupId) {
  return await AxiosGet(jwt, `${api_url}/Api/BroadcastGroup/getBroadcastGroup?broadcastGroupId=${broadcastGroupId}`)
}

export async function trApiSendBroadcastSMS(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/SMS/BroadcastMessage`, body)
}

//Audio

export async function trApiAudioRemoveHangupEvent(jwt, eventId) {
  return await AxiosGet(jwt, `${api_url}/Queue?eventId=${eventId}`)
}

export async function trApiGetTwilioAudioToken(jwt, staff_id) {
  return await AxiosGet(jwt, `${api_url}/voice/token?staffIdentifier=${staff_id}`)
}

export async function trApiAudioGetCallHistory(jwt, staffNumber, participant_phone_primary) {
  return await AxiosGet(jwt, `${api_url}/Voice/History?staffNumber=${staffNumber}&participantNumber=${participant_phone_primary}`)
}

//Chat

export async function trApiSendChatMessageToParticipant(jwt, smsBody) {
  return await AxiosPost(jwt, `${api_url}/Chat/PeerToParticipantMessage`, smsBody)
}

export async function trApiGetChatHistory(jwt, convSid) {
  return await AxiosGet(jwt, `${api_url}/Chat/ChatHistory?convSid=${convSid}`)
}

export async function trApiGetChatConversationSid(jwt, peerId, caseId, orgId) {
  return await AxiosGet(jwt, `${api_url}/Chat/GetConversationId?peerId=${peerId}&caseId=${caseId}&orgId=${orgId}`)
}

//Invalid Messages

export async function trApiGetInvalidMessagesListByOrgId(jwt, orgId) {
  return await AxiosGet(jwt, `${api_url}/InvalidMessages?orgId=${orgId}`)
}
export async function trApiInvalidMessageSetRead(jwt, data) {
  return await AxiosPost(jwt, `${api_url}/InvalidMessages/SetRead`, data)
}
export async function trApiInvalidMessageReply(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/InvalidMessages/BroadcastMessage`, body)
}

//External Calls
export async function trApiFindStaffAndOrgNumber(jwt, staffId, organization_Id, organization_alias, staff_alias) {
  return await AxiosGet(jwt, `${api_url}/Numbers/FindByStaffAndOrg?staffId=${staffId}&groupId=${organization_Id}&groupAlias=${organization_alias}&staffAlias=${staff_alias}`)
}
export async function trApiGetExternalCallHistory(jwt, fromNumber) {
  const encodedPhoneNumber = encodeURIComponent(fromNumber)
  return await AxiosGet(jwt, `${api_url}/Voice/History?fromNumber=${encodedPhoneNumber}`)
}
export async function trApiGetPhoneSuggestions(jwt, fromNumber) {
  const encodedPhoneNumber = encodeURIComponent(fromNumber)
  return await AxiosGet(jwt, `${api_url}/ExternalCalls/PreviousCallsNumbers?from=${encodedPhoneNumber}`)
}
export async function trApiAddParticipantExternalCall(jwt, data) {
  return AxiosPost(jwt, `${api_url}/ExternalCalls/AddParticipant`, data)
}
export async function trApiDisconnectExternalCall(jwt, data) {
  return AxiosPost(jwt, `${api_url}/ExternalCalls/DisconnectCalls`, data)
}
